import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { compareDisplayNames } from '@utils/string.util';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  DeviceCountViewModel,
  TenantDetailDialogViewModel,
} from './tenant-detail-dailog.model';

@Component({
  selector: 'app-tenant-detail-dailog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
  ],
  templateUrl: './tenant-detail-dailog.component.html',
  styleUrl: './tenant-detail-dailog.component.scss',
})
export class TenantDetailDailogComponent {
  @ViewChild('deviceInput') deviceInput:
    | ElementRef<HTMLInputElement>
    | undefined;

  /** テナントID */
  public tenantId: string;

  /** テナント名 */
  public tenantName: string;

  /** 説明 */
  public description: string;

  /** 会社名 */
  public companyName: string;

  /** 会社ロゴパス */
  public companyLogoPath?: string;

  /** 管理者数 */
  public adminCount?: number;

  /** ユーザー数 */
  public userCount?: number;

  /** デバイス種類数 */
  public deviceCounts?: DeviceCountViewModel[];

  /** 設定テンプレート数 */
  public assetTypeCount?: number;

  /** 配送数 */
  public shipmentCount?: number;

  /** 位置情報数 */
  public shipmentLocationCount?: number;

  /** ルート数 */
  public shipmentRouteCount?: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) options: TenantDetailDialogViewModel,
    private dialogRef: MatDialogRef<TenantDetailDailogComponent>,
    private dialog: MatDialog,
  ) {
    this.tenantId = options.tenantId;
    this.tenantName = options.tenantName;
    this.description = options.description;
    this.companyName = options.companyName;
    this.companyLogoPath = options.companyLogoPath;
    this.adminCount = options.adminCount;
    this.userCount = options.userCount;
    this.deviceCounts = options.deviceCounts?.slice().sort((a, b) =>
      compareDisplayNames(a.deviceTypeDisplayName, b.deviceTypeDisplayName),
    );
    this.assetTypeCount = options.assetTypeCount;
    this.shipmentCount = options.shipmentCount;
    this.shipmentLocationCount = options.shipmentLocationCount;
    this.shipmentRouteCount = options.shipmentRouteCount;
  }
}
